import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { HeaderDataProps, HeaderLinksDataProps } from '../../components/navigation/header/Header';
import { LogoProps } from '../../components/navigation/header/Logo';
import { SecondaryHeaderDataProps } from '../../components/navigation/header/secondaryHeader/SecondaryHeader';
import { AMPPrimaryHeader } from './AMPPrimaryHeader';
import { CtaDataProps } from '../../components/navigation/header/primaryHeader/CtaButton';
import { AMPSideBar } from './AMPSideBar';
import { AMPSecondaryHeader } from './AMPSecondaryHeader';
import { EditionDataProps } from '../../components/navigation/header/primaryHeader/Editions';

interface AMPHeaderProps {
    primaryLinks: HeaderLinksDataProps[] | null
    primaryLogos: LogoProps
    editions: EditionDataProps[] | null
    cta: CtaDataProps | null
    secondaryHeader: SecondaryHeaderDataProps | null
    shouldShowClosedMenuIcon: boolean
    pagePath: string
    editionEndpoint: string
}

const getHeaderStyle = () => StyleSheet.create({
  wrapper: {
    position: 'fixed',
    width: '100%',
    zIndex: 1500,
    top: 0,
  },
});

export const AMPHeader:React.FunctionComponent<AMPHeaderProps> = props => {
  const { primaryLinks, primaryLogos, cta, shouldShowClosedMenuIcon, secondaryHeader, editions, editionEndpoint, pagePath } = props;
  const style = getHeaderStyle();
  return (
    <header className={css(style.wrapper)}>
      <AMPPrimaryHeader primaryLinks={primaryLinks} primaryLogos={primaryLogos} cta={cta} shouldShowClosedMenuIcon={shouldShowClosedMenuIcon} editions={editions} pagePath={pagePath} editionEndpoint={editionEndpoint} />
      {secondaryHeader ? <AMPSecondaryHeader {...secondaryHeader} pagePath={pagePath} /> : null}
    </header>
  );
};


export const AMPHeaderAndSideBar:React.FunctionComponent<HeaderDataProps> = props => {
  const { secondaryHeader, primaryHeader } = props;
  const { primaryLinks, primaryLogos, editions, cta, menu, editionEndpoint, pagePath } = primaryHeader;
  return (
    <React.Fragment>
      <AMPHeader primaryLinks={primaryLinks} primaryLogos={primaryLogos} secondaryHeader={secondaryHeader} cta={cta} shouldShowClosedMenuIcon={!!menu} editions={editions} pagePath={pagePath} editionEndpoint={editionEndpoint} />
      { menu ? <AMPSideBar menu={menu} editions={editions} editionEndpoint={editionEndpoint} /> : null}
    </React.Fragment>
  );
};
